module.exports = __webpack_public_path__ + "static/tu-2.d97a3383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tu-2.jpg
// module id = 680
// module chunks = 95714099722567